import React, { useState, useEffect } from "react";
import { Button, Card, CardGroup, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
import "./EbookPage.scss";
import { Ebook, IntegrationIcon } from "../../../asset/json/CardDetail";
import "../../common/tooltip.css";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import Reveal from "react-reveal/Reveal";
import Background from "../../../asset/image/backgroundImage.svg";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import { TrialButton } from "../../common/Buttons";
import firebase from "../../../firebase";
import { CardActionArea, CardMedia, Typography, makeStyles, CardContent } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    // maxWidth: 345,
    width: 260,
    borderRadius: 10,
    marginBottom: "10%",
    fontFamily: "Montserrat",
  },
  media: {
    height: 160,
  },
  font: {
    fontFamily: "Montserrat",
  },
});
const EbookPage = () => {
  const classes = useStyles();

  const [ebooks, setEbooks] = useState([]);
  console.log("ebooks", ebooks);
  useEffect(() => {
    const ref = firebase.collection("/eBooks");
    function getData() {
      ref.onSnapshot((data) => {
        const item = [];
        data.forEach((doc) => {
          item.push(doc.data());
        });
        //  setEbooks(item);
        setEbooks(
          item.sort((a, b) => {
            return b.id - a.id;
          })
        );
      });
    }
    getData();
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  //
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const pdfUrls = "https://www.cloudsocial.io/wp-content/uploads/2023/The%20Ultimate%20Instagram%20Marketing%20Guide-For%20Beginners%20in%202023.pdf";

  const handlePdfOpen = () => {
    // Open the PDF in a new tab.
    // window.open(pdfUrls, "_blank");
    setShow(false);
  };
  const handleShow = (url) => {
    if (localStorageData !== null) {
      window.open(url, "_blank");
      console.log("if", localStorageData);
    } else {
      setShow(true);
      console.log("else", localStorageData);
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    // Other form fields
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      createdAt: new Date(),
    });
  };

  const validateForm = () => {
    const newErrors = {};
    // Add validation rules here
    if (!formData.name) {
      newErrors.name = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Invalid phone number format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      firebase
        .collection("blogEbookForm")
        .add(formData)
        .then(() => {
          console.log("Form submitted successfully!");
          handlePdfOpen();
          setFormData({
            name: "",
            email: "",
            phoneNumber: ""
          });
          // setPdfUrl(serverResponse.pdfUrl);
          // history.push('/ebook'); 
          localStorage.setItem("user", formData);
          window.open(pdfUrls, "_blank");
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
        });
    }
  };


  const localStorageData = localStorage.getItem("user");
  console.log("localStorageData", localStorageData);

  // localStorage.removeItem("user");
  //
  return (
    <div >
      <Helmet>
        <meta
          charSet="utf-8"
          name="Cloudsocial : All social E-book in your pocket"
        />
        <meta
          name="description"
          content="CloudSocial provides all the E-book resources which guide you to succeed in the CloudSocial media marketing platform. Check out our learning materials."
        />
        <title>E-bbok | CloudSocial</title>
        <link rel="canonical" href="https://cloudsocial.io/ebook" />
      </Helmet>
      <Container
        fluid
        style={{
          background: "#F5FBFF ",
          backgroundImage: `url(${Background})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="card-media">

          <Zoom top>
            <h1 className="media-title mt-3">E-Book</h1>
          </Zoom>
          <div className="link-btn">
            <TrialButton />
          </div>
          <Zoom cascade>
            <h2 className="media-subtitle mt-2">
            Elevate your social media marketing game with our free in-depth guides.
            </h2>
          </Zoom>

          <hr className="divider" />
          <Container >
            <Row xs={1} md={2} className="g-5" style={{ display: "flex", justifyItems: "center", justifyContent: "center", alignItems: "center" }}>
              {ebooks.map((ebook) => {
                const { id, img, url, title, alt } = ebook;
                return (
                  <div className="cardEbook cardBlog" key={id} onClick={() => { handleShow(url) }} >
                    <CardGroup >
                      <Card
                        style={{ margin: "5px", cursor: "pointer", }}
                        text="dark"
                        className="blogs"
                      >
                        <Card.Img variant="top" src={img} alt={alt} />
                        <Card.Body className="p-1">
                          <Card.Text className="social-title">{title}</Card.Text>
                        </Card.Body>
                      </Card>
                    </CardGroup>
                  </div>
                );
              })}
            </Row>
          </Container>
          <hr className="mt-5" style={{ width: "90%" }} />
        </div>
      </Container>
      <Modal
        size="md"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="modelHeader" closeButton>
          Form
        </Modal.Header>
        <Modal.Body className="model-body" style={{ padding: "10px" }}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                isInvalid={!!errors.phoneNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phoneNumber}
              </Form.Control.Feedback>
            </Form.Group>
            <div style={{ textAlign: "end" }}>
              <Button type="submit" className="login">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default EbookPage;
